import { useState, useEffect, useCallback, useRef } from 'react';

/**
 * Loads data for a screen: handles loading/error state and gives back a
 * reload function.
 *
 *   const { data, loading, error, reload } = useData(() => api.student(id), [id]);
 */
export default function useData(loader, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Guards against a slow first request resolving after a newer one and
  // overwriting fresher data.
  const runId = useRef(0);

  const run = useCallback(async () => {
    const id = ++runId.current;
    setLoading(true);
    setError(null);
    try {
      const result = await loader();
      if (id === runId.current) setData(result);
    } catch (err) {
      if (id === runId.current) setError(err.message || 'فشل تحميل البيانات');
    } finally {
      if (id === runId.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => { run(); }, [run]);

  return { data, loading, error, reload: run, setData };
}
